import {
  i
} from "./chunk.775UL347.js";

// src/assets/scripts/reset.css.ts
var reset_css_default = i`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  *:focus-visible {
    outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
    outline-offset: 6px;
    outline-style: var(--focus-outline-style, auto);
  }

  div,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  ol,
  ul,
  li,
  form,
  label,
  table,
  header,
  footer,
  nav,
  section,
  figure {
    margin: 0;
    padding: 0;
  }

  a,
  button,
  input,
  select,
  textarea {
    color: inherit;
  }
`;

export {
  reset_css_default
};
